export default __webpack_public_path__ + "static/desktop_left-b61a5f4e157342ff472c291537fdafb5.png";